
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社伊藤総業
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
              ホーム
            </Link>
            <div className="relative group">
              <button className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer flex items-center">
                事業内容
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-lg rounded-lg border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2">
                  <Link to="/used-cars" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 cursor-pointer">
                    中古車販売・買取・輸出
                  </Link>
                  <Link to="/renewable-energy" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 cursor-pointer">
                    再生可能エネルギー
                  </Link>
                  <Link to="/energy-storage" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 cursor-pointer">
                    蓄電所運営
                  </Link>
                  <Link to="/web-development" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 cursor-pointer">
                    ホームページ制作
                  </Link>
                  <Link to="/real-estate" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 cursor-pointer">
                    不動産売買
                  </Link>
                </div>
              </div>
            </div>
            <Link to="/company" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
              会社概要
            </Link>
            <Link to="/contact" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              お問い合わせ
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                ホーム
              </Link>
              <div className="space-y-2">
                <div className="text-gray-700 font-medium">事業内容</div>
                <div className="pl-4 space-y-2">
                  <Link to="/used-cars" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                    中古車販売・買取・輸出
                  </Link>
                  <Link to="/renewable-energy" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                    再生可能エネルギー
                  </Link>
                  <Link to="/energy-storage" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                    蓄電所運営
                  </Link>
                  <Link to="/web-development" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                    ホームページ制作
                  </Link>
                  <Link to="/real-estate" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                    不動産売買
                  </Link>
                </div>
              </div>
              <Link to="/company" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                会社概要
              </Link>
              <Link to="/contact" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors text-center cursor-pointer">
                お問い合わせ
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
